@if (this.stageName(); as stageName) {
  <span>{{ stageName }}</span>
} @else {
  <glxy-blank-value></glxy-blank-value>
}
